import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Text, Spacer } from '@ontruck/orc';

import { StyledSnackbar } from './styled';

class Snackbar extends Component {
  static propTypes = {
    message: PropTypes.string,
    actionText: PropTypes.string,
    snackbarAction: PropTypes.object,
  };

  render() {
    const { message, actionText, snackbarAction } = this.props;

    const action = () => {
      snackbarAction && snackbarAction.callback();
    };

    return (
      !!message && (
        <StyledSnackbar>
          <Spacer mBottom="XS">
            <Text weight="bold">{message}</Text>
          </Spacer>
          <Button onClick={action} neutral fullWidth small>
            {actionText}
          </Button>
        </StyledSnackbar>
      )
    );
  }
}

export default connect(
  (state) => ({
    message: state.snackbarText,
    autoHideDuration: state.snackbarDuration,
    actionText: (state.snackbarAction && state.snackbarAction.label) || null,
    snackbarAction: state.snackbarAction,
  }),
  {}
)(Snackbar);
